import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"padding":"20px"} }
const _hoisted_2 = { style: {"padding":"30px 20px"} }
const _hoisted_3 = { style: {"padding":"30px 20px"} }
const _hoisted_4 = { style: {"padding":"30px 20px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!

  return (_openBlock(), _createBlock(_component_van_cell_group, null, {
    default: _withCtx(() => [
      _createVNode(_component_van_field, {
        modelValue: $setup.viewModel.phone,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.viewModel.phone) = $event)),
        label: "检测带登录账号"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_van_field, {
        modelValue: $setup.viewModel.password,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.viewModel.password) = $event)),
        label: "检测带登录密码"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_van_field, {
        modelValue: $setup.viewModel.bedId,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.viewModel.bedId) = $event)),
        label: "重力感应床Id"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_van_field, {
        modelValue: $setup.viewModel.mainBoardId,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.viewModel.mainBoardId) = $event)),
        label: "重力感应主板Id"
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_van_radio_group, {
          modelValue: $setup.viewModel.addressCode,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.viewModel.addressCode) = $event)),
          direction: "horizontal"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_radio, { name: 0 }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("广州", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_van_radio, { name: 1 }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("深圳", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_button, {
          type: "primary",
          block: "",
          onClick: $setup.save
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createTextVNode("保存", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_button, {
          type: "primary",
          block: "",
          onClick: $setup.openRealtime
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createTextVNode("开启重力实时数据", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_van_button, {
          type: "primary",
          block: "",
          onClick: $setup.flash
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
            _createTextVNode("重力归零", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }))
}